import axios from 'axios';

export const getOrgInfo = () => axios.get('get_org');

export const getUsersResumes = (query) => axios.get(`users/resumes${query || ''}`);

export const getUsers = (currentPage, rowsPerPage, search) =>
  axios.get(`users?page=${currentPage}&limit=${rowsPerPage}${search ? `&search=${search}` : ''}`);

export const getResultTestByTestId = (testId) => axios.get(`get_user_tests?test_id=${testId}`);

export const getResultDates = (userId) => axios.get(`get_user_tests?user_id=${userId}`);

export const userInventory = () => axios.get(`inventory/listing?page=1&limit=100`);

export const addUser = (name, lastName, email, password, mobileNumber) => {
  const userData = {
    name,
    lastName,
    email,
    password,
    mobileNumber,
  };
  return axios.post('user/create', userData);
};

export const updateUser = (id, name, lastName, email, password, mobileNumber) => {
  const userData = {
    name,
    lastName,
    email,
    password,
    mobileNumber,
  };
  return axios.put(`user/update?user=${id}`, userData);
};

export const bulkCreate = (formData) =>
  axios.post('users/bulk-create', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });

export const deleteUser = (id) => axios.put(`user/delete?user=${id}`);

export const bulkRemove = (users) =>
  axios.put('users/bulk-remove', {
    users,
  });

export const transferOrganization = (users) =>
  axios.post('payment/transfer-organization', {
    users,
  });

export const uploadOrgLogo = (formData) =>
  axios.post('auth/upload-logo', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });

export const removeOrgLog = () => axios.post('auth/remove-logo', {});
